@for (erpPromo of erpPromotionalTexts; track erpPromo) { @if (erpPromo && erpPromo !== '') {
<span>
  {{ erpPromo }}
</span>
} }
